<template>
<main>
  <p>
    Forms require at least 4 customized fields:
    <ul>
      <li>The form ID in the form's action endpoint</li>
      <li>The form ID in the form's name field</li>
      <li>The form ID in the form's JS</li>
      <li>The ReCaptcha Site Key</li>
    </ul>
  </p>

  <p>
    All forms currently require the following fields: <strong>"email"</strong>
  </p>
  <p>Forms may otherwise be customized to fit the client's needs, including:
    <ul>
      <li>Field names and order</li>
      <li>Addition or removal of fields</li>
      <li>Style &amp; HTML layout</li>
      <li>Additional JS Validation</li>
    </ul>
  </p>
  <p>Forms with file uploads may need further configuration</p>
  <button class="clipboard" @click="copy">Copy to clipboard</button>
  <pre><code class="hljs language-html language-javascript">{{html}}</code></pre>
</main>
</template>

<script>
import highlightjs from 'highlight.js/lib/core';
import hljsXml from 'highlight.js/lib/languages/xml';
import hljsJavascript from 'highlight.js/lib/languages/javascript';
import '@/assets/hljs-atom-one-dark.css';
import {
  CheckCircleIcon, XCircleIcon, MessageSquareIcon,
  CalendarIcon, MailIcon, ShieldIcon, FileIcon, ExternalLinkIcon,
} from 'vue-feather-icons';

highlightjs.registerLanguage('html', hljsXml);
highlightjs.registerLanguage('javascript', hljsJavascript);
export default {
  props: ['form'],
  data() {
    return { /* eslint-disable no-useless-escape */
      html: `
<form action="${this.$store.getters.endpoint}/${this.form.id}" method="post" name="${this.form.id}">
  <div class="form-group">
      <label for="name">Name</label>
      <input name="name" type="text" required>
  </div>

  <div class="form-group">
      <label for="phone">Phone</label>
      <input name="phone" type="tel" required>
  </div>

  <div class="form-group">
      <label for="email">Email</label>
      <input name="email" type="email" required>
  </div>

  <div class="form-group">
    <label for="message">Message</label>
    <textarea name="message" cols="25" rows="5" required></textarea>
  </div>
  
  <input name="Form URL" type="hidden">

  <input value="Submit" type="submit">
  
  <div class="g-recaptcha" 
    data-sitekey="${this.form.captchaSite}" 
    data-callback='onSubmit' 
    data-size="invisible" 
    data-badge="inline">
  </div> 
    
<script src="https://www.google.com/recaptcha/api.js" async defer><\/script>
<script>
var form = document.forms['${this.form.id}'];
form['Form URL'].value = document.location;
form.onsubmit = function(e) {
e.preventDefault();
if (!form.checkValidity()) form.reportValidity();
else grecaptcha.execute();
}
function onSubmit(token) { form.submit(); }
<\/script>

</form>`, /* eslint-disable */
    };
  },
  methods: {
    copy() {
      navigator.clipboard.writeText(this.html)
      .then(() => {
        document.querySelector('.clipboard').classList.toggle('copied')
        setTimeout(() => {
        document.querySelector('.clipboard').classList.toggle('copied')
        }, 1000)
      })
      .catch((e) => console.error(`Could not copy to clipboard: ${e}`))
    }
  },
  mounted() {

  highlightjs.highlightAll();
  },
  components: {
    CheckCircleIcon,
    XCircleIcon,
    MessageSquareIcon,
    CalendarIcon,
    MailIcon,
    ShieldIcon,
    FileIcon,
    ExternalLinkIcon,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

main { padding: 0; }
p { margin-left: 1.5em; }
pre { margin: 0; }
code { padding: 1.5em; }
.clipboard {
  width: 100%;
  padding: 2em;
  border: 0;
  border-bottom: 1px solid white;
  background: #282c34;
  color: var(--white);
  text-transform: uppercase;
  cursor: pointer;
  transition: color 0.2s ease-in;
}
.clipboard:hover { background: var(--black); }
.clipboard.copied { color: var(--green); }


</style>
